import store from "../store";
import Constants from "../config/constants";
import { serviceGetCostCenter } from "../services/CostCenter.service";

export const FETCH_INIT = "FETCH_INIT_COST_CENTER";
export const FETCHED = "FETCHED_COST_CENTER";
export const FETCHED_FAIL = "FETCHED_FAIL_COST_CENTER";
export const FETCHED_FILTER = "FETCHED_FILTER_COST_CENTER";
export const FETCH_NEXT = "FETCH_NEXT_COST_CENTER";
export const FILTER = "FILTER_COST_CENTER";
export const RESET_FILTER = "RESET_FILTER_COST_CENTER";
export const SET_SORTING = "SET_SORTING_COST_CENTER";
export const SET_FILTER = "SET_FILTER_COST_CENTER";
export const SET_PAGE = "SET_PAGE_COST_CENTER";
export const CHANGE_PAGE = "CHANGE_PAGE_COST_CENTER";
export const CHANGE_STATUS = "CHANGE_STATE_COST_CENTER";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_COST_CENTER";
export const CREATE_DATA = "CREATE_COST_CENTER";
export const UPDATE_DATA = "UPDATE_COST_CENTER";
export const DELETE_ITEM = "DELETE_COST_CENTER";
export const GET_EMPLOYEE_DATA = "GET_COST_CENTER_DATA";

export function actionFetchCostCenter(index = 1, sorting = {}, filter = {}) {
  const request = serviceGetCostCenter({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({
          type: FETCHED,
          payload: {
            data: data.data,
            total: data?.data?.total,
            page: index,
          },
        });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePageCostCenterRequests(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterCostCenterRequests(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null }); //dispatch function
    });
  };
}

export function actionResetFilterCostCenterRequests() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionSetPageCostCenterRequests(page) {
  const stateData = store.getState().cost_center;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchCostCenter(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
